import React from 'react';
import { Upload, Icon, message, Modal } from 'antd';
import styles from './Index.less';

function getUrllistByFilelist(fileList) {
  const urlList = [];

  fileList.forEach(item => {
    if (item.response && item.response.data.urls) {
      urlList.push(item.response.data.urls[0] || '');
    } else if (item.url) {
      urlList.push(item.url);
    }
  });

  return urlList;
}

export default class UploadImage extends React.Component {
  constructor(props) {
    super(props);

    const initFileList = [];
    if (props.initialValue) {
      props.initialValue.forEach((item, index) => {
        initFileList.push({
          uid: index,
          url: item,
        });
      });
    }

    this.state = {
      previewVisible: false,
      previewImage: '',
      fileList: initFileList || [],
    };

    this.curImgCanUpload = false;
    this.handleRemove = this.handleRemove.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.beforeUpload = this.beforeUpload.bind(this);
    this.handlePreview = this.handlePreview.bind(this);
    this.handlePreviewCancel = this.handlePreviewCancel.bind(this);
  }

  // antd组件要求：必须每次调用setState保证fileList同步
  handleChange({ file, fileList }) {
    if (!this.curImgCanUpload) {
      return false;
    }

    if (file.status === 'done') {
      message.success('图片上传成功');
      if (typeof this.props.onChange === 'function') {
        this.props.onChange(getUrllistByFilelist(fileList));
      }
    }

    this.setState({ fileList });
  }

  handleRemove(file) {
    const { fileList } = this.state;

    fileList.some((item, index, arr) => {
      if (item === file) {
        arr.splice(index, 1);
        return true;
      }
      return false;
    });

    if (typeof this.props.onChange === 'function') {
      this.props.onChange(getUrllistByFilelist(fileList));
    }

    this.setState({ fileList });
  }

  handlePreview(file) {
    this.setState({
      previewImage: file.url || file.thumbUrl,
      previewVisible: true,
    });
  }

  handlePreviewCancel() {
    this.setState({
      previewVisible: false,
    });
  }

  beforeUpload(file) {
    const { imgMaxSize } = this.props;
    const imgType = ['image/jpeg', 'image/jpg', 'image/png'];

    const isImgType = imgType.some(type => file.type === type);
    if (!isImgType) {
      message.warning('图片格式仅支持jpg、png、jpeg格式');
      this.curImgCanUpload = false;
      return false;
    }

    const isLimit = file.size / 1024 / 1024 < imgMaxSize;
    if (!isLimit) {
      message.warning(`图片大小需要小于${imgMaxSize}M`);
      this.curImgCanUpload = false;
      return false;
    }

    this.curImgCanUpload = true;

    return isImgType && isLimit;
  }

  previewImgModal() {
    const { previewVisible, previewImage } = this.state;

    return (
      <Modal visible={previewVisible} footer={null} onCancel={this.handlePreviewCancel}>
        <img alt="商品图片" className={styles['preview-img']} src={previewImage} />
      </Modal>
    );
  }

  editContent() {
    const uploadButton = (
      <div className="upload-btn-container">
        <Icon type="plus" />
        <div className="ant-upload-text">上传图片</div>
      </div>
    );
    const { uploadApi, uploadField, uploadParam, description, maxLength } = this.props;
    const { fileList } = this.state;

    return (
      <div className={styles.root}>
        <Upload
          action={uploadApi}
          listType="picture-card"
          name={uploadField}
          data={uploadParam}
          onPreview={this.handlePreview}
          fileList={fileList}
          beforeUpload={this.beforeUpload}
          onChange={this.handleChange}
          onRemove={this.handleRemove}
        >
          {fileList.length >= maxLength ? null : uploadButton}
        </Upload>
        {this.previewImgModal()}
        <p className={styles['upload-description']}>{description}</p>
      </div>
    );
  }

  renderContent() {
    const { fileList } = this.state;

    if (fileList.length === 0) {
      return <div className={styles.root}>无</div>;
    }

    return (
      <div className={styles.root}>
        <Upload
          listType="picture-card"
          showUploadList={{
            showPreviewIcon: true,
            showRemoveIcon: false,
          }}
          onPreview={this.handlePreview}
          fileList={fileList}
        />
        {this.previewImgModal()}
      </div>
    );
  }

  render() {
    const { type } = this.props;

    return type === 'edit' ? this.editContent() : this.renderContent();
  }
}



// WEBPACK FOOTER //
// ./src/components_business/UploadImage/Index.js